<div class="tw-flex md-max:tw-flex-col tw-gap-x-16 md-max:tw-gap-y-0">
  <ng-container *ngIf="window.innerWidth < resizeBreakpoint || filtersHiddenByDefault; else openedFiltersTemplate">
    <div
      *ngIf="showIcon"
      class="filter-panel__icon tw-flex tw-items-center pointer {{ drawer.opened ? 'filter-panel_hidden' : '' }} {{
        isFullPage ? 'filter-panel__icon__full-page' : ' filter-panel__icon__under-navbar'
      }}"
      (click)="drawer.toggle()"
    >
      <ui-svg-icon class="filter-color" [name]="iconNameList.Filter"></ui-svg-icon>

      <span *ngIf="!!filtersCount" class="filters-count">{{ filtersCount }}</span>
      <span
        *ngIf="showFilterBtnLabel"
        class="filter-color"
        [ngStyle]="{ 'padding-left': filtersCount ? '15px' : '4px' }"
      >
        {{ 'monitoring.filters.filters' | translate }}
      </span>
    </div>

    <mat-drawer-container
      class="mat-drawer-container {{
        monitoringPageService.matDrawer$.getValue()?.opened ? 'mat-drawer-container__opened' : ''
      }}"
      [hasBackdrop]="true"
    >
      <mat-drawer #drawer [autoFocus]="false" [mode]="'over'" position="end">
        <ng-container *ngTemplateOutlet="filters"></ng-container>
      </mat-drawer>
      <mat-drawer-content [ngClass]="{ 'tw-pt-0': noIndents }">
        <ng-container *ngTemplateOutlet="list"></ng-container>
      </mat-drawer-content>
    </mat-drawer-container>
  </ng-container>

  <ng-template #openedFiltersTemplate>
    <div class="filters-container">
      <ng-container *ngTemplateOutlet="filters"></ng-container>
    </div>

    <div class="list tw-flex tw-flex-col">
      <ng-container *ngTemplateOutlet="list"></ng-container>
    </div>
  </ng-template>
</div>

<ng-template #list>
  <ng-content select="[list]"></ng-content>
</ng-template>

<ng-template #filters>
  <ng-content select="[filters]"></ng-content>
</ng-template>
